import React from 'react';
import TermsSection, { SectionText, BulletPoint } from './TermsSection';

const ServiceDescription = () => {
  return (
    <TermsSection title="1. Service Description">
      <SectionText>Campus Insights provides:</SectionText>
      <BulletPoint>
        • Smart, AI-powered chat support designed for colleges and universities
      </BulletPoint>
      <BulletPoint>
        • Anonymous conversations by default, with optional sign-in for students who choose a more personalized experience
      </BulletPoint>
      <BulletPoint>
        • Real-time, non-identifiable insights that help institutions understand trends and improve student support
      </BulletPoint>
      <BulletPoint>
        • Accessible via college websites, portals, or as an embeddable widget — available wherever students need guidance.
      </BulletPoint>
    </TermsSection>
  );
};

export default ServiceDescription;
